// @vue/component
export default {
  name: 'ReportsFormExportItemProject',

  props: {
    currentField: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      clientUuid: '',
      fieldValue: '',
      projectUuid: '',
      rules: [
        { required: true, validator: this.__validateAgentValues },
      ],
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/projects/list',
        'client/project/agents/list',
      ]);
    },
    getProjectsList() {
      return this.$store.getters['client/projects/list'].records;
    },
    getAgentsList() {
      if (this.projectUuid !== '') return this.$store.getters['client/project/agents/list'].records;
      return [];
    },
  },

  watch: {
    projectUuid() {
      if (this.projectUuid !== '') this.$store.dispatch('client/project/agents/getList', [this.projectUuid]);
    },
  },

  created() {
    this.$store.dispatch('client/projects/getList');
  },

  methods: {
    __validateAgentValues(rule, value, callback) {
      if (value !== '') callback();
      callback(new Error('Nie wybrano agenta'));
    },
  },
};
